module.exports = __webpack_public_path__ + "static/media/_gcp0.377b79de.jpg";